import { faCamera, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { FileActionFunction, FileItemType } from '../../types/communication/communicationDataType';
import { customLabel, uploadExecutionHandler } from '../../utils/utils-file';
import { LInvertedButton } from '../styled/Button.style';
import { LCardSinistro } from '../styled/Containers.style';
import { ButtonFileInput, FileCard, FileInput, FileInputs } from '../styled/File.style';
import { LIconContainer } from '../styled/Icon.style';
import { LSimpleText } from '../styled/Text.style';

export interface FileUploadCmpProps {
    onFileAdded: FileActionFunction;
    onFileRemoved: FileActionFunction;
    showSupportedFilesInfo?: boolean;
    className?: string;
    fileType: string;
    textLabel?: string;
    files?: FileItemType[];
    companyName?: string;
    maxLimit?: number;
    isInMultiCard?: boolean;
    customUploadHandler?: (event: any) => void;
}

const FileUploadCmp = ({
    onFileAdded,
    onFileRemoved,
    showSupportedFilesInfo = false,
    className = '',
    fileType,
    textLabel = 'AGGIUNGI',
    files = [],
    companyName,
    maxLimit,
    isInMultiCard,
    customUploadHandler
}: FileUploadCmpProps) => {

    const { token } = useParams();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const filesLength = files?.length;

    const triggerInput = () => fileInputRef.current?.click();

    const uploadHandler = (event: any) => {
        if (customUploadHandler) {
            customUploadHandler(event);
        } else {
            uploadExecutionHandler(event, fileType, token, onFileRemoved, onFileAdded);
        }
    }

    const isInMultiCardClass = isInMultiCard ? 'is-in-multi-card' : ''
    const renderUploadButton = () => {
        const canUploadMore = !maxLimit || filesLength < maxLimit;
        if (companyName === "LINEAR") {
            if (canUploadMore) {
                return (
                    <LCardSinistro className={isInMultiCardClass}>
                        <LInvertedButton onClick={triggerInput} style={{ margin: 0, width: "100%" }}>
                            <LIconContainer><FontAwesomeIcon icon={faPlus} /></LIconContainer>
                            {textLabel}
                        </LInvertedButton>
                    </LCardSinistro>
                );
            }
            else {
                return <LSimpleText className={`max-limit-warning ${isInMultiCardClass}`}>Hai raggiunto il limite massimo di file caricabili</LSimpleText>
            }
        }

        return (
            <ButtonFileInput onClick={triggerInput}>
                <i><FontAwesomeIcon icon={faCamera} /></i>
                {customLabel(files?.length, textLabel)}
            </ButtonFileInput>
        );
    };

    return (
        <>
            <FileCard className={`${className} ${companyName} ${isInMultiCardClass}`}>
                <FileInputs className={companyName}>
                    <FileInput
                        ref={fileInputRef}
                        type="file"
                        accept="image/*,.pdf"
                        onChange={uploadHandler}
                    />
                </FileInputs>
                {renderUploadButton()}
                {showSupportedFilesInfo && companyName !== "LINEAR" && (
                    <>
                        <p className="main">Supported files</p>
                        <p className="info">PDF, JPG, PNG</p>
                    </>
                )}
            </FileCard>
        </>
    );
};

export default FileUploadCmp;
